/**
 * Created by Edward on 15/05/2017.
 */

import SliderClassicCounter from './SliderClassicCounter'

export default SliderClassicCounter
